export default "__VITE_ASSET__0e14356e__"